import React from 'react'

const Iframe = ({ src, title }) => <iframe className='w-full h-screen rounded' src={src} title={title} />

export default Iframe
